import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { FormattedMessage } from "react-intl";

import Video from "../Commons/Video";
import { VideoGuidanceName, VIDEOS_PLAYBACK_CONFIGS } from "../constants";

/**
 * Shared educational content component that provides information about security keys.
 *
 * This component displays a comprehensive introduction to security keys used at Amazon,
 * including what they are, how they're used for multi-factor authentication, and basic
 * usage instructions. The content includes a video overview and explanatory
 * text that helps users understand the purpose and importance of security keys in the
 * Amazon security ecosystem.
 *
 * @returns JSX element containing educational content about security keys
 */
export default function SecurityKeyEducationalContent(): JSX.Element {
  return (
    <Col rowGap="S300">
      <Video
        videoFileConfig={
          VIDEOS_PLAYBACK_CONFIGS[VideoGuidanceName.SECURITY_KEY_OVERVIEW]
        }
      />

      <Text fontSize="T300" fontWeight="bold" dataTestId="securityKeyHeading">
        <FormattedMessage id="insertAndTestSecurityKey-educationalContent-securityKeyHeading" />
      </Text>

      <Text fontWeight="regular" dataTestId="securityKeyDescription1">
        <FormattedMessage id="insertAndTestSecurityKey-educationalContent-securityKeyDescription1" />
      </Text>

      <Text fontWeight="regular" dataTestId="securityKeyDescription2">
        <FormattedMessage id="insertAndTestSecurityKey-educationalContent-securityKeyDescription2" />
      </Text>

      <Text fontWeight="regular" dataTestId="securityKeyDescription3">
        <FormattedMessage id="insertAndTestSecurityKey-educationalContent-securityKeyDescription3" />
      </Text>
    </Col>
  );
}
